import { useState } from 'react';
import { Quote, ChevronLeft, ChevronRight, Star } from 'lucide-react';
import { testimonials } from '../../mock';

export default function Testimonials() {
  const [idx, setIdx] = useState(0);
  const next = () => setIdx((i) => (i + 1) % testimonials.length);
  const prev = () => setIdx((i) => (i - 1 + testimonials.length) % testimonials.length);
  const t = testimonials[idx];

  return (
    <section
      id="testimonials"
      className="section-anchor py-20 md:py-28 bg-[#0b6b5b] text-white relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-10 pointer-events-none" aria-hidden="true">
        <div className="absolute -top-20 -right-20 h-80 w-80 rounded-full bg-[#f3c14a]" />
        <div className="absolute -bottom-24 -left-24 h-96 w-96 rounded-full bg-white" />
      </div>

      <div className="relative max-w-5xl mx-auto px-5 md:px-8 text-center">
        <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3.5 py-1.5 text-xs font-semibold tracking-wide text-[#f3c14a]">
          <span className="h-1.5 w-1.5 rounded-full bg-[#f3c14a]" />
          TESTIMONIALS
        </div>
        <h2 className="mt-5 font-display text-4xl md:text-5xl font-semibold leading-tight">
          What our clients say
        </h2>
        <div className="flex items-center justify-center gap-1 mt-4">
          {[...Array(5)].map((_, i) => (
            <Star key={i} className="h-5 w-5 fill-[#f3c14a] text-[#f3c14a]" />
          ))}
        </div>

        <div className="mt-10 bg-white/[0.08] backdrop-blur-sm rounded-3xl border border-white/10 p-8 md:p-12 min-h-[280px] flex flex-col items-center justify-center">
          <Quote className="h-10 w-10 text-[#f3c14a] mb-5" />
          <p className="font-display text-xl md:text-2xl leading-relaxed text-white max-w-3xl">
            “{t.quote}”
          </p>
          <div className="mt-6">
            <div className="font-display font-semibold text-lg">{t.name}</div>
            <div className="text-sm text-white/70">{t.role}</div>
          </div>
        </div>

        <div className="mt-7 flex items-center justify-center gap-3">
          <button
            onClick={prev}
            aria-label="Previous testimonial"
            className="h-11 w-11 grid place-items-center rounded-full bg-white/10 hover:bg-white/20 transition-colors"
          >
            <ChevronLeft className="h-5 w-5" />
          </button>
          <div className="flex gap-1.5">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setIdx(i)}
                aria-label={`Go to testimonial ${i + 1}`}
                className={`h-2 rounded-full transition-all ${
                  i === idx ? 'w-8 bg-[#f3c14a]' : 'w-2 bg-white/30'
                }`}
              />
            ))}
          </div>
          <button
            onClick={next}
            aria-label="Next testimonial"
            className="h-11 w-11 grid place-items-center rounded-full bg-white/10 hover:bg-white/20 transition-colors"
          >
            <ChevronRight className="h-5 w-5" />
          </button>
        </div>
      </div>
    </section>
  );
}
